<template>
    <div class="tray collision" v-bind:class="[{ active: isActive}]">
        <h2 class="tray-h2 collision-h2" v-if="collision.date">
            {{ collision.date }} <span v-if="collision.time">@ {{collision.time}}</span>
            <i v-on:click="clearCollision" class="material-icons tray-icon-close">close</i>
        </h2>

        <div class="tray-instructions" v-else>
            Loading collision...
        </div>

        <h3 class="tray-h3 collision-h3" v-if="collision.location">
            {{ collision.location }}
        </h3>

        <div class="l-clearfix collision-fields" v-if="collision.date">
            <div class="collision-field" v-if="collision.people">
                <i class="material-icons">person</i> {{ collision.people }} {{ collision.people > 1 ? 'people' : 'person' }}
            </div>
            
            <div class="collision-field" v-if="collision.pedestrians">
                <i class="material-icons">directions_walk</i> {{ collision.pedestrians }} {{ collision.pedestrians > 1 ? 'pedestrians' : 'pedestrian' }}
            </div>

            <div class="collision-field" v-if="collision.cyclists">
                <i class="material-icons">directions_bike</i> {{ collision.cyclists }} {{ collision.cyclists > 1 ? 'cyclists' : 'cyclist' }}
            </div>

            <div class="collision-field" v-if="collision.vehicles">
                <i class="material-icons">directions_car</i> {{ collision.vehicles }} {{ collision.vehicles > 1 ? 'vehicles' : 'vehicle' }}
            </div>

            <div class="collision-field" v-if="collision.injuries">
                <span class="tray-label">Injuries</span> {{ collision.injuries }}
            </div>

            <div class="collision-field" v-if="collision.serious_injuries">
                <span class="tray-label">Serious injuries</span> {{ collision.serious_injuries }}
            </div>

            <div class="collision-field" v-if="collision.fatalities">
                <span class="tray-label">Fatalities</span> {{ collision.fatalities }}
            </div>
    
            <div class="collision-field" v-if="collision.light_condition">
                <div class="tray-label">Light conditions</div>
                {{ collision.light_condition }}
            </div>

            <div class="collision-field" v-if="collision.hitparkedcar">
                <span class="tray-label">Hit parked car?</span> Yes
            </div>

            <div class="collision-field" v-if="collision.road_condition">
                <div class="tray-label">Road conditions</div>
                {{ collision.road_condition }}
            </div>

            <div class="collision-field" v-if="collision.speeding">
                <span class="tray-label">Speeding</span> Yes
            </div>

            <div class="collision-field" v-if="collision.under_influence">
                <span class="tray-label">Under the influence of drugs or alcohol</span> Yes
            </div>
            
            <div class="collision-field" v-if="collision.weather">
                <div class="tray-label">Weather</div>
                {{ collision.weather }}
            </div>

            <div class="collision-field" v-if="collision.address_type">
                <div class="tray-label">Address type</div>
                {{ collision.address_type }}
            </div>

            <div class="collision-field" v-if="collision.coldetkey">
                <div class="tray-label">Collision detail key</div>
                {{ collision.coldetkey }}
            </div>

            <div class="collision-field" v-if="collision.collision_type">
                <div class="tray-label">Collision type</div>
                {{ collision.collision_type }}
            </div>

            <div class="collision-field" v-if="collision.junction_type">
                <div class="tray-label">Junction type</div>
                {{ collision.junction_type }}
            </div>

            <div class="collision-field" v-if="collision.inattention">
                <span class="tray-label">Due to inattention?</span> {{ collision.inattention }}
            </div>

            <div class="collision-field" v-if="collision.inckey">
                <div class="tray-label">Incident key</div>
                {{ collision.inckey }}
            </div>
            
            <div class="collision-field" v-if="collision.reportno">
                <div class="tray-label">Report number</div>
                {{ collision.reportno }}
            </div>
            
            <div class="collision-field" v-if="collision.sdot">
                <div class="tray-label">SDOT code {{ collision.sdot.collision_code }}</div>
                <div v-if="collision.sdot.collision_title">
                    {{ collision.sdot.collision_title }}
                </div>
            </div>

            <div class="collision-field" v-if="collision.severity.code">
                <div class="tray-label">Severity code {{ collision.severity.code }}</div>
                {{ collision.severity.description }}
            </div>

            <div class="collision-field" v-if="collision.spd_case_number">
                <div class="tray-label">SPD case number</div>
                {{ collision.spd_case_number }}
            </div>

            <div class="collision-field" v-if="collision.state_collision_code">
                <div class="tray-label">State collision code</div>
                {{ collision.state_collision_code }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'collision',

  computed: {
    collision () {
      return this.$store.getters['collisionsView/collision/get']
    },

    isActive () {
      return (Object.keys(this.collision).length) ? 1 : 0
    }
  },

  methods: {
    clearCollision () {
      this.$store.dispatch('collisionsView/collision/reset')
    }
  },

  watch: {
    isActive: function () {
      let app = document.getElementById('app')

      if (this.isActive) {
        app.classList.add('s-tray-active')
      } else {
        app.classList.remove('s-tray-active')
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/tray.scss";
@import "./src/sass/components/collision.scss";
</style>



// WEBPACK FOOTER //
// Collision.vue?2321c48d